<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>

    <side-bar
      :sidebar-item-color="sidebarBackground"
      :sidebar-background-image="sidebarBackgroundImage"
    >
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/app-notifications">
        <md-icon>notifications</md-icon>
        <p>Send Notifications</p>
      </sidebar-link>
      <sidebar-link to="/pop-ups">
        <md-icon>campaign</md-icon>
        <p>PopUps</p>
      </sidebar-link>
      <sidebar-link to="/meta-data">
        <md-icon>tag</md-icon>
        <p>Meta Data</p>
      </sidebar-link>
      <sidebar-link to="/banners">
        <md-icon>collections</md-icon>
        <p>Banners</p>
      </sidebar-link>
      <sidebar-link to="/promotions">
        <md-icon>local_offer</md-icon>
        <p>Promotions</p>
      </sidebar-link>
      <sidebar-link to="/contacts">
        <md-icon>contacts</md-icon>
        <p>Contacts</p>
      </sidebar-link>
      <sidebar-link to="/social-media-handles">
        <md-icon>groups</md-icon>
        <p>Social Media Handles</p>
      </sidebar-link>
      <sidebar-link to="/licence">
        <md-icon>verified</md-icon>
        <p>Licence Number</p>
      </sidebar-link>
      <sidebar-link to="/privacy-policy">
        <md-icon>security</md-icon>
        <p>Privacy Policy</p>
      </sidebar-link>
      <sidebar-link to="/affiliates-terms-and-conditions">
        <md-icon>handshake</md-icon>
        <p>Affiliates Terms</p>
      </sidebar-link>
      <sidebar-link to="/conflicts-and-resolutions">
        <md-icon>report_problem</md-icon>
        <p>Conflicts and Resolutions</p>
      </sidebar-link>
      <sidebar-link to="/terms-and-conditions">
        <md-icon>rule</md-icon>
        <p>Terms and Conditions</p>
      </sidebar-link>
      <sidebar-link to="/bonus-policy">
        <md-icon>redeem</md-icon>
        <p>Bonus Policy</p>
      </sidebar-link>
      <sidebar-link to="/important-info">
        <md-icon>info</md-icon>
        <p>Important Info</p>
      </sidebar-link>
      <sidebar-link to="/responsible-gamming">
        <md-icon>sports_esports</md-icon>
        <p>Responsible Gamming</p>
      </sidebar-link>
      <sidebar-link to="/faq">
        <md-icon>help_outline</md-icon>
        <p>FAQ</p>
      </sidebar-link>

      <button class="btn btn-sm btn-danger mx-4 mt-2" @click="handleLogout">
        <md-icon>logout</md-icon>
        <span class="text-white" style="margin-left: 8px">Logout</span>
      </button>
    </side-bar>
    <div class="modal" v-if="showLogoutModal">
      <div class="modal-content" style="width: 70%">
        <div class="modal-header">
          <h5 class="modal-title" style="color: blue">Confirm Logout</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <h6 style="color: black">Are you sure you want to log out?</h6>

        <button class="btn btn-danger" @click="handleLogout">Yes</button>
        <button class="btn btn-primary" @click="showLogoutModal = false">
          No
        </button>
      </div>
    </div>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content> </dashboard-content>

      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "@/pages/Layout/MobileMenu.vue";
import Cookies from "js-cookie";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
    MobileMenu,
  },
  data() {
    return {
      showLogoutModal: false,
      sidebarBackground: "green",
      sidebarBackgroundImage: require("@/assets/img/sidebar-2.jpg"),
    };
  },
  methods: {
    logout() {
      this.showLogoutModal = true;
    },
    handleLogout() {
      Cookies.remove("authToken");
      this.$router.push("/login");
    },
  },
};
</script>
